/**
 * Where the app sends people for help that lives outside the app.
 *
 * The documentation is a separate public site rather than pages in here, so
 * every link to it goes through one place — and keeps working in local
 * development, where the docs run on their own port.
 */

const FALLBACK_DOCS_ORIGIN = 'https://docs.dialup.lv';

/** Support inbox, shown in the help menu and on the help page. */
export const SUPPORT_EMAIL = 'team@dialup.lv';

export function getDocsOrigin(): string {
  const configured = import.meta.env.VITE_DOCS_ORIGIN;
  const origin =
    typeof configured === 'string' && configured.trim().length > 0
      ? configured.trim()
      : FALLBACK_DOCS_ORIGIN;

  return origin.replace(/\/$/, '');
}

/**
 * A link into the documentation. `getDocsUrl()` is the home page;
 * `getDocsUrl('/getting-started/getting-calls-to-your-agent')` is one article.
 */
export function getDocsUrl(pathname = ''): string {
  if (!pathname) return getDocsOrigin();
  const suffix = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${getDocsOrigin()}${suffix}`;
}
